export default {
  es: {
    company_name: "Nombre de la empresa",
    contact_name: "Nombre y apellidos del contacto",
    phone: "Teléfono",
    email: "Email",
    message: "Mensaje",
    attach_invoice: "Adjuntar factura",
  },
  en: {},
};



// WEBPACK FOOTER //
// ./src/translations/fields.js